import { Route } from 'react-router-dom';
import { PublicLayout } from 'components';

const PublicRoute = (props: any) => {
    return (
        <PublicLayout>
            <Route {...props} />
        </PublicLayout>
    );
}

export default PublicRoute;